<div class="uploadfilecontainer start-center flex-row flex"
     cbDragDrop
     (onFileDropped)="uploadFile($event)">
    <input hidden
           type="file"
           #fileInput
           [required]="true"
           (click)="$event.target.value = null"
           (change)="uploadFile($event?.target?.files)" />
    @if (!(isFileValidAndUploaded$ | async)) {
        <div layout-padding
             class="cb-margin-3x flex-col flex"
        >
            <div>
                <h4 class="cb-padding-bottom">{{ (file$ | async)?.name }}</h4>
                <div class="cb-padding-bottom">{{ description }}</div>
                @if (maximumFileSizeInMegaBytes) {
                    <div class="cb-padding-bottom"
                    ><strong>Max Size</strong>:
                        {{ maximumFileSizeInMegaBytes }}MB
                    </div>
                }
                @if (allowedFileTypes) {
                    <h4>Allowed File Types</h4>
                }
                @for (type of allowedFileTypes; track type) {
                    <li>
                        {{ FILE_TYPE_ENUM[type] }}
                    </li>
                }
            </div>
        </div>
    }
    @if ((isFileValidAndUploaded$ | async)) {
        <div layout-padding
             class="cb-margin-3x flex-row flex"
        >
            <h4> {{ (file$ | async)?.name }}</h4>
        </div>
    }
    <div class="cb-margin-right"
         (click)="fileInput?.click()">
        <button style="width: 60px;height: 60px;"
                mat-icon-button
                color="accent">
            <mat-icon>attach_file_outline</mat-icon>
        </button>
    </div>
</div>
<div class="flex-col">
    @if (!isFileExtensionValid) {
        <div
            class="icon-text">
            <mat-icon color="warn"
                      class="cb-margin-right-2x">report_problem
            </mat-icon>
            <span>
          The file you have selected has the wrong extension .{{ fileExtension }}. Please select a file with one
          of the extensions:
                @for (type of allowedFileTypes; track type; let last = $last) {
                    <span>{{
                            last ?
                                FILE_TYPE_ENUM[type] + '. ' : FILE_TYPE_ENUM[type] + ', '
                        }}</span>
                }
        </span>
        </div>
    }
    @if (!isFilesizeValid) {
        <div
            class="icon-text">
            <mat-icon color="warn"
                      class="cb-margin-right-2x">report_problem
            </mat-icon>
            <span> The file you have selected is {{ fileSizeFormatted }}. This is too large. Please select a file under
                {{ maximumFileSizeInMegaBytes }}MB. </span>
        </div>
    }
</div>
